/**
 * This holds current apply state along with required parameters
 *
 */
import { JobStore } from '../../store';
import { getParamFromUrl, sanitizeRole } from '../../utils/index';
import { toggleJobListDisplay } from '../../actions/JobSearchActions';
import { toggleSkipApplyInitiatedFlag, toggleQuickApplyInitiatedFlag, setUtmParameters } from '../../actions/ApplyActions';
import webStorageWrapper from '../WebStorageWrapper';
import IndexedDbWrapper from '../IndexedDbWrapper';
import ApplyCookieHelper from './ApplyCookieHelper';
import store from '../../store';
import root from 'window-or-global';
import { toggleCallUnlockCandidateBuyOptions } from '../../actions/ApplyActions';


export default class Apply {

  step = 0;
  type = 'DEFAULT';
  job = { //Current Job for which the apply is called.Only required Fields added
    id: '',
    title: '',
    snbUrl: '/jobs',
    cityId: ''
  };
  disableInputs = false;
  directApplyAdId = null; // used to initiate apply from amp
  refDirectApplyAdId = null; // used to pass source in apply request
  applySource = null;
  discount = 0;
  showCallUnlockBuyOptions = false;
  applyForm = {};
  hasNewStepTwoAnswers = false;
  isSkipApplyInitiated = false;
  isQuickApplyInitiated = false;

    constructor() {
      this.setDirectApplyDetails();
      this.setApplySourceFromUrl();
    }

    static getApplyStore(key) {
       return JobStore.getState().apply[key];
    }

    static getJobsAppliedInSessionCount() { 
        let count = webStorageWrapper.getSessionStorage().get('totalJobsAppliedInSession');
        count = count ? parseInt(count, 10) : 0;
        return count;
    }

    static incrementJobsAppliedInSession() {
        let jobsAppliedInSession = Apply.getJobsAppliedInSessionCount();
        let count = jobsAppliedInSession ? jobsAppliedInSession + 1 : 1;
    
        webStorageWrapper.getSessionStorage().set('totalJobsAppliedInSession', count);
    }

    static getJobFromStore(adId) {
        let searchedJob = null, jobs =  JobStore.getState().jobSearch.jobs;
        
        if(jobs.length > 0) {
            jobs.forEach(item => {
                if(adId == item.id)
                    searchedJob = item;
            });
        }

        return searchedJob;
    }
     
    setDirectApplyDetails = () => {
        if (root.location && root.location.pathname.search('zwqxj') >= 0) {
            let adId = getParamFromUrl('adId');

            if (adId) {
                this.directApplyAdId = adId;
                this.refDirectApplyAdId = adId;
            }
        }
    };

    // set apply source from url if present
    setApplySourceFromUrl = () => {
        if (root.location && root.location.pathname.search('zwqxj') >= 0) {
            let applySource = getParamFromUrl('source');
            if (applySource) {
                this.applySource = applySource;
            }
        }
    };

    static toggleJobListDisplay(show) {
        JobStore.dispatch(toggleJobListDisplay(show));
    }

    static updateSavedAppliesFromIDB () {
      try {
        const applyCookieHelper = new ApplyCookieHelper();
        let appliedJobs = applyCookieHelper.getAppliedJobs();

        // get failed jobs to be removed from cookies and indexeddb
        const { applyTransaction, applyObjects } = IndexedDbWrapper.getAppliedJobsByStatus('failed');
        if (!applyTransaction) {return;}
        applyTransaction.oncomplete = function () {
          // check for indexeddb failed apply objects and update cookie
          // so that the user can view the failed jobs again in snb
          if (applyObjects && applyObjects.length === 0) {return;}

          applyObjects.forEach(value => {
            const applyIndex = appliedJobs.indexOf(value.adid);
            if (applyIndex > -1) {
              appliedJobs.splice(applyIndex, 1);
            }
            // remove the apply object from indexeddb
            IndexedDbWrapper.removeApplyFromIdb(value);
          });
          // update the cookie with the new applied jobs array
          applyCookieHelper.setAppliedJobs(appliedJobs);

          appliedJobs = applyCookieHelper.getAppliedJobs();
          const updatedApply = { appliedJobs };
          store.dispatch({ type: 'UPDATE_APPLY', payload: updatedApply });
        };
      } catch (e) {
        if (typeof JobsSentry !== 'undefined') {
          JobsSentry.captureMessage("Exception occurred while removing applies from idb.\nMessage : " + e.message + ".\nStack : " + e.stack);
        }
      }
    }


  static toggleCallUnlockCandidateBuyBannerVisibility = value => {
    JobStore.dispatch(toggleCallUnlockCandidateBuyOptions(value));
  };

  static isApplyWithoutEmailEnabled = (role, city) => {
    let isEnabled = false;
    let formattedRole = sanitizeRole(role).toLowerCase();
    let formattedCity = sanitizeRole(city).toLowerCase();
    formattedCity = formattedCity.replace('x:', '');
    let config = Apply.getApplyStore('emailNonMandatoryConfig');
    if (config) {
      let isRoleEnabled = (
        (
          config.areAllRolesEnabled
        )
        ||
        (
          config.enabledRoles && (config.enabledRoles.indexOf(formattedRole) > -1)
        )
      );

      let isCityEnabled = (
        (
          config.areAllCitiesEnabled
        )
        ||
        (
          config.enabledCities && (config.enabledCities.indexOf(formattedCity) > -1)
        )
      );

      isEnabled = isRoleEnabled && isCityEnabled;
    }

    return isEnabled;
  };

  static toggleSkipApplyInitiatedFlag = value => {
    store.dispatch(toggleSkipApplyInitiatedFlag(value));
  };

  static toggleQuickApplyInitiatedFlag = value => {
    store.dispatch(toggleQuickApplyInitiatedFlag(value));
  };

  static setUtmParameters = value => {
    store.dispatch(setUtmParameters(value));
  };

}



// WEBPACK FOOTER //
// ../q-jobs/src/utils/Apply/index.js